export default __webpack_public_path__ + "static/media/mopit_icon.7f1a092a.png";